<template>
  <div class="loader-screen">
    <div class="hyper-bg">
      <div
        v-for="i in rows"
        :key="i"
        class="row"
        :class="[
          i % 2 === 0 ? 'ltr' : 'rtl',
          ready ? 'start' : ''
        ]"
        :style="initialStyle(i)"
      >
        <div class="row-inner">
          <span v-for="j in 14" :key="'a'+j">Hyper</span>
          <span v-for="j in 14" :key="'b'+j">Hyper</span>
        </div>
      </div>
    </div>

    <div class="loader-text pulse">Компания создаётся…</div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const rows = 14;
const ready = ref(false);

// 👇 Ключевой момент!
function initialStyle(i) {
  return {
    transform: i % 2 === 0
      ? "translateX(-1500px)"   // ltr старт за левым краем
      : "translateX(1500px)"    // rtl старт за правым краем
  };
}

onMounted(() => {
  // ждём применение transform → потом включаем анимацию
  requestAnimationFrame(() => {
    ready.value = true;
  });
});
</script>

<style scoped>
.loader-screen {
  position: fixed;
  inset: 0;
  background: #2887f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 999999;
}

/* фон */
.hyper-bg {
  position: absolute;
  inset: 0;
  transform: rotate(-15deg);
  display: flex;
  flex-direction: column;
  gap: 34px;
}

/* строки */
.row {
  white-space: nowrap;
  opacity: 0.88;
  will-change: transform;
}

/* содержимое */
.row-inner {
  display: inline-flex;
  gap: 45px;
}

.row-inner span {
  font-family: "Eastman-ExtraboldItalic", sans-serif;
  font-size: 40px;
  color: rgba(255,255,255,0.93);
}

/* движение после ready */
.row.start.ltr {
  animation: move-ltr 6s linear infinite;
}

.row.start.rtl {
  animation: move-rtl 6s linear infinite;
}

/* движения */
@keyframes move-ltr {
  0%   { transform: translateX(-1500px); }
  100% { transform: translateX(1500px); }
}

@keyframes move-rtl {
  0%   { transform: translateX(1500px); }
  100% { transform: translateX(-1500px); }
}

/* текст */
.loader-text {
  margin-top: 80px;
  color: white;
  font-size: 24px;
  text-shadow: 0 0 8px rgba(0,0,0,0.35);
}

/* пульсация */
.pulse {
  animation: pulse 1.3s ease-in-out infinite alternate;
}

@keyframes pulse {
  0%   { transform: scale(1); opacity: 0.85; }
  100% { transform: scale(1.05); opacity: 1; }
}
</style>